import React from 'react';
import { Formik, Form } from 'formik';
import Select from '../FormsUI/Select';
import Button from '../FormsUI/Button';
import { useState } from 'react';
import { userExportFormValidation } from '../../Utils/UserValidations';
import { getAllUserDataToExport } from '../../API/APICalls';
import Loading from '../Loading';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


const UserExportForm = ({ id, domainIds }) => {
    const [loading, setLoading] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const file_types = { 1: 'csv', 2: 'xlsx' };
    const formData = { domain_id: [], file_types: 1 };

    const closeWindow = () => { 
        setTimeout(() => { window.close(); }, 5 * 1000);
    };

    const downloadCSV = (jsonData, filename = 'data.csv') => {
        if (!jsonData || jsonData.length === 0) {
            console.error('No data provided for CSV export.');
            return;
        }
        const csv = Papa.unparse(jsonData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, `${filename}.csv`);
        closeWindow();
    };

    const downloadXLSX = (jsonData, filename = 'data.xlsx') => {
        if (!jsonData || jsonData.length === 0) {
            console.error('No data provided for XLSX export.');
            return;
        }
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });
        const data = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(data, `${filename}.xlsx`);
        closeWindow();
    };

    const downloadFile = ({ data, fileName, fileType }) => {
        if (fileType === 'csv') {
            downloadCSV(JSON.stringify(data), fileName);
        };
        if (fileType === 'xlsx'){
            downloadXLSX(data, fileName);
        }
    };

    const handleSubmitForm = async (values) => {
        setButtonDisabled(true);
        try {
            setLoading(true);
            let response = await getAllUserDataToExport(id, values.domain_id);
            if (!response?.data?.length > 0) {
                alert('No data found..');
            } else {
                const responseData = response.data.map(item => {
                    if (item.country_ids) {
                        const updatedItem = { ...item, country_info: item.country_ids };
                        delete updatedItem.country_ids;
                        return updatedItem;
                    }
                    delete item.country_ids;
                    item.email = item.local_part + '@' + item.domain_name;
                    return item;
                });
                const timestamp = new Date().toISOString().replace(/:/g, '-').replace('T', '-').split('.')[0];
                downloadFile({
                    data: responseData,
                    fileName: `user_details_export_${timestamp}`,
                    fileType: file_types[values.file_types]
                });
            }
        } catch (error) {
            console.error(error.message);
        } finally {
            setLoading(false);
            setButtonDisabled(false);
        };
    }
    if (loading) {
        return <Loading />
    };

    return (
        <>
            <Formik initialValues={formData} validationSchema={userExportFormValidation} onSubmit={handleSubmitForm}>
                <Form style={{ display: 'flex', flexDirection: 'row', gap: 15, width: '95%', margin: '0 auto', padding: '2rem', boxShadow: 3 }}>
                    <Select name='domain_id'
                        label='Domain name'
                        options={domainIds}
                        noneRequired={false}
                        multiple />

                    <Select name='file_types'
                        label='File type'
                        options={file_types}
                        noneRequired={false} />
                    <Button variant='contained' color='primary' size='small' type='submit' disabled={buttonDisabled} >
                        Download
                    </Button>
                </Form>
            </Formik>
        </>
    )
}

export default UserExportForm;
